import React from 'react';
export const footerBasicType = 'basic';
export const footerLegalTextType = 'legalText';
export const FooterContext = React.createContext(footerLegalTextType);